import './promotion-card.scss';
